import { NavLink } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles } from '../style/gotheme';
import PageRow from './PageRow';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import CloseIcon from '@material-ui/icons/Close';
import LinkIcon from '@material-ui/icons/Link';
import DescriptionIcon from '@material-ui/icons/Description';

const styles = theme => {
  return Object.assign({
    getLink: {
      textAlign: 'right',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    watchYouTube: {
      display: 'inline-block',
      padding: '6px 10px',
      borderRadius: '28px',
      '&:hover': {
        backgroundColor: '#eeeeee'
      }
    },
    videoThumbnail: {
      width: 340,
      height: 200,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4
    },
    videoCard: {
      width: 340,
      maxWidth: '100%',
      marginRight: 20,
      marginBottom: 20,
      borderRadius: 4,
      boxShadow: '0px 6px 12px #00000029',
      backgroundColor: 'white'
    },
    wpCard: {
      width: 340,
      maxWidth: '100%',
      padding: 12,
      margin: 12,
      borderRadius: 4,
      boxShadow: '0px 6px 12px #00000029',
      backgroundColor: 'white'
    }
  }, globalStyles)
};

const videos = [
  {
    name: "Inviting users to your Graphologi subscription",
    desc: "Learn how to invite users to collaborate with you on your data.",
    image: "inviting-users.png",
    link: "https://youtu.be/mSPk_y9VS60"
  },
  {
    name: "Create a project",
    desc: "Creating a project is the first step to managing your taxonomies, ontologies or datasets.",
    image: "create-project.png",
    link: "https://youtu.be/H9G7a1ttPSo"
  },
  {
    name: "Add project languages",
    desc: "Add additional languages to your project after it has been created.",
    image: "add-project-language.png",
    link: "https://youtu.be/yt68vvKUCRs"
  },
  {
    name: "Create and manage project snapshots",
    desc: "Snapshots allows you to make backups of your projects.",
    image: "setup-snapshots.png",
    link: "https://youtu.be/9XvwYbHal4I"
  },
  {
    name: "Working with polyhierarchy or monohierarchy",
    desc: "Learn how a taxonomy has options allowing you to control how you want your data structured.",
    image: "editing-mode.png",
    link: "https://youtu.be/bQM2hYdcM0U"
  },
  {
    name: "Using classes",
    desc: "Learn how to apply classes and set up default classes.",
    image: "add-class.png",
    link: "https://youtu.be/lmumxTDHlAM"
  },
  {
    name: "Using templates",
    desc: "Learn how to configure and use templates to enrich your taxonomies and data.",
    image: "use-template.png",
    link: "https://youtu.be/T94EFBzp6T0"
  },
  {
    name: "Creating suggestions",
    desc: "Learn how suggestions allow users to contribute ideas to a taxonomy.",
    image: "new-top-concept-suggestion.png",
    link: "https://youtu.be/POBM-OZnMJw"
  },
  {
    name: "Creating connections outside of a project",
    desc: "Create connections to other taxonomy projects and to linked data sources.",
    image: "links.png",
    link: "https://youtu.be/MWh9cMR0yJY"
  },
  {
    name: "Basic import of a taxonomy from a spreadsheet",
    desc: "Learn the basics of how too import spreadsheets, TSV and CSV files.",
    image: "import-spreadsheet.png",
    link: "https://youtu.be/449AH-sKrnk"
  },
  {
    name: "Advanced spreadsheet import",
    desc: "Import spreadsheets using relationships, ontology properties and classes.",
    image: "advanced-spreadsheet-import.png",
    link: "https://youtu.be/iXpS1d-vJyo"
  },
  {
    name: "Create a spreadsheet output for a taxonomy",
    desc: "Learn how to set up tabular outputs such as spreadsheets and CSV.",
    image: "create-tsv.png",
    link: "https://youtu.be/9OqeocDKbeg"
  },
  {
    name: "Predefined Reports",
    desc: "Run predefined reports to better understand your projects.",
    image: "reporting.png",
    link: "https://youtu.be/zziQ5SxIsv0"
  }
]

class Learn extends Component {

  constructor(props) {
    super(props);
    const isLinked = props.location.hash.substring(1);
    const selected = isLinked ?
      videos.find(video => video.link === isLinked)
      :
      null;
    this.state = {
      selected
    };
  }

  select = (video) => {
    this.props.history.push("/learn#" + video.link);
    this.setState({ selected: Object.assign({}, video) })
  };

  unselect = () => {
    this.props.history.push("/learn");
    this.setState({ selected: null })
  }

  render() {

    const { classes, width, tutorials } = this.props;
    const { selected } = this.state;
    const isLarge = width === "md" || width === "lg" || width === "xl";

    return (
      <div>
        {isLarge &&
          <div style={{ position: 'absolute', overflow: 'hidden', width: '100%', right: 0 }}>
            <img
              src="/images/GraphologiIcon.svg"
              style={{
                float: 'right',
                height: 764,
                marginTop: '-100px',
                marginRight: -160
              }}
              alt="" />
          </div>
        }
        <PageRow spaceTop={isLarge ? "100px" : "36px"}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h1">Learn</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" style={{ marginTop: 18 }} paragraph>Find out more about taxonomies, ontologies and knowledge graphs,<br /> plus how to get the best from Graphologi.</Typography>
            </Grid>
          </Grid>
        </PageRow>
        <PageRow spaceTop={isLarge ? "70px" : "20px"} color="#F2F7FF">
          <Typography style={{ marginBottom: 40 }} paragraph align="center" variant="h1">Resources</Typography>
          <div style={{ display: isLarge ? 'flex' : 'block', flexWrap: 'wrap', justifyContent: 'center' }}>
            {tutorials.map((tutorial, index) =>
              <div key={index} className={classes.wpCard}>
                <div style={{ paddingBottom: 40 }}>
                  <Typography variant="caption"><DescriptionIcon fontSize="large" style={{ verticalAlign: 'middle' }} /> Tutorial</Typography>
                  <div style={{ marginTop: 20 }}>
                    <Typography variant="h2">{tutorial.title}</Typography>
                  </div>
                </div>
                <div style={{ clear: 'both' }}>
                  <div style={{ height: tutorial.longTitle ? 120 : 180 }}>
                    <Typography paragraph variant="body1">{tutorial.description}</Typography>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <NavLink to={"/" + tutorial.url + "/"}>
                      <PrimaryButton onClick={() => { }}>Read</PrimaryButton>
                    </NavLink>
                  </div>
                </div>
              </div>
            )}
          </div>
        </PageRow>
        <PageRow spaceTop={isLarge ? "70px" : "20px"} color="#F2F7FF">
          <Typography style={{ marginBottom: 40 }} paragraph align="center" variant="h1">Video Tutorials</Typography>
          <div style={{ display: isLarge ? 'flex' : 'block', flexWrap: 'wrap', justifyContent: 'center' }}>
            {videos.map((video, index) =>
              <div key={index} className={classes.videoCard}>
                <div>
                  <img
                    className={classes.videoThumbnail}
                    src={"/images/" + video.image}
                    alt={video.name} />
                  <div style={{ textAlign: 'center', borderBottom: 'solid 1px #f0f0f0', paddingTop: 12, paddingBottom: 12 }}>
                    <Typography>
                      <a href={video.link} target="_new" className={classes.watchYouTube}>
                        <PlayIcon
                          color="secondary"
                          style={{ height: 40, width: 40, verticalAlign: 'middle' }} />
                        <span style={{ marginLeft: 12 }}>Watch on YouTube</span>
                      </a>
                    </Typography>
                  </div>
                </div>
                <div style={{ padding: 8 }}>
                  <Typography paragraph variant="body2" style={{ height: '2.4em' }}>{video.name}</Typography>
                  <Typography variant="body1">{video.desc}</Typography>
                  <div className={classes.getLink}>
                    <CopyToClipboard text={video.link}>
                      <Tooltip title="Copy link to video">
                        <LinkIcon />
                      </Tooltip>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
            )}
          </div>
        </PageRow>
        {selected &&
          <div>
            <div className={classes.playBackground} />
            <div className={isLarge ? classes.closeContainer : classes.narrowCloseContainer}>
              <Tooltip title="Close video player">
                <CloseIcon className={classes.close} onClick={this.unselect} />
              </Tooltip>
            </div>
            <div className={isLarge ? classes.viewer : classes.narrowViewer}>
              <div style={{ height: 'calc(100% - 100px)' }}>
                <iframe
                  style={{ height: '100%', width: '100%' }}
                  src={selected.link}
                  title={selected.name}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen></iframe>
              </div>
              <div style={{ padding: 12 }}>
                <Typography paragraph variant="body2">{selected.name}</Typography>
                {isLarge &&
                  <Typography variant="body1">{selected.desc}</Typography>
                }
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

Learn.propTypes = {
}

export default withRouter(withWidth()(withStyles(styles)(Learn)));